import {createContext, ReactElement, useState} from "react";
import {IMapContextProps} from "../interfaces/mapInterfaces";
import * as maptalks from "maptalks";
import React from "react";


export const mapContext = createContext({} as IMapContextProps);
const {Provider} = mapContext;

export const MapContextComponent = ({children} : {children? : ReactElement | ReactElement[]}) => {

    const [map, setMap] = useState({} as maptalks.Map)


    const mapContextValue : IMapContextProps = {
        map : map,
        setMap : setMap,
    }

    return (
        <Provider value = {mapContextValue}>
            {children}
        </Provider>
    )
}



